import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/app'
    },
    {
      path: '/app',
      name: 'Application',
      component: () => import('@/components/framework/Application')
    }, {
      path: '/auth',
      name: 'Auth',
      component: () => import('@/components/framework/Auth')
    }, {
      path: '/error',
      name: 'Error',
      component: () => import('@/components/framework/Error')
    }
  ]
})
router.beforeEach((to, from, next) => {
  // console.log('app.router->' + to.name)
  // 判断该路由是否需要登录权限
  if (to.name === 'Auth' || to.name === 'Error') {
    next()
  } else {
    let beeId = Vue.getCache('beeId')
    // console.log('app.router.token->' + beeId)
    if (!beeId) {
      // console.log('app.router.auth->failure. redirect:/auth')
      next({ name: 'Auth' })
    } else {
      next()
    }
  }
})

router.afterEach((to, from, next) => {
  // console.log('app.router.after->' + to.name)
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js